import * as S from './index.style'
import React, { ElementType, useState } from 'react'
import { InputBaseComponentProps } from '@material-ui/core/InputBase'
import TextField from '@material-ui/core/TextField'
import { DadosPermuta, ValidacaoDadosPermuta } from 'models/Viabilidade/Permuta'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { secaoOpcional } from 'helpers/Constantes/Mensagens'

const Permuta: React.FC<{ dadosPermuta: DadosPermuta; dadosPermutaHandler: (novoValor: DadosPermuta) => void }> = ({ dadosPermuta, dadosPermutaHandler }) => {
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosPermuta())
  const [valores, setValores] = useState(dadosPermuta)

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosPermuta
    setValores(state)
    dadosPermutaHandler(state)
  }

  const validarPermutaNoLocalFiscalCasas = () => {
    const erroPermutaNoLocalFiscalCasas = mensagensErro.validarInputUsuario(valores.permutaNoLocalFiscalCasas.toString())

    const validador = new ValidacaoDadosPermuta(
      erroPermutaNoLocalFiscalCasas,
      mensagensErro.permutaNoLocalFiscalLotes,
      mensagensErro.permutaForaDoLocalFiscal,
      mensagensErro.porcentagemDescontoPermutaFinanceira,
      mensagensErro.valorEscrituradoTerreno,
      mensagensErro.valorEscrituradoTerreno
    )

    setMensagensErro(validador)
  }

  const validarPermutaNoLocalFiscalLotes = () => {
    const erroPermutaNoLocalFiscalLotes = mensagensErro.validarInputUsuario(valores.permutaNoLocalFiscalLotes.toString())

    const validador = new ValidacaoDadosPermuta(
      mensagensErro.permutaNoLocalFiscalCasas,
      erroPermutaNoLocalFiscalLotes,
      mensagensErro.permutaForaDoLocalFiscal,
      mensagensErro.porcentagemDescontoPermutaFinanceira,
      mensagensErro.valorEscrituradoTerreno,
      mensagensErro.valorEscrituradoTerreno
    )

    setMensagensErro(validador)
  }

  const validarPermutaForaDoLocalFiscal = () => {
    const erroPermutaForaDoLocalFiscal = mensagensErro.validarInputUsuario(valores.permutaForaDoLocalFiscal.toString())

    const validador = new ValidacaoDadosPermuta(
      mensagensErro.permutaNoLocalFiscalCasas,
      mensagensErro.permutaNoLocalFiscalLotes,
      erroPermutaForaDoLocalFiscal,
      mensagensErro.porcentagemDescontoPermutaFinanceira,
      mensagensErro.valorEscrituradoTerreno,
      mensagensErro.valorEscrituradoTerreno
    )

    setMensagensErro(validador)
  }

  const validarPermutaFinanceiraBruta = () => {
    const erroPermutaFinanceiraBruta = mensagensErro.validarInputPorcentagemUsuario(valores.porcetagemVgvPermutaFinanceiraBruta.toString())

    const validador = new ValidacaoDadosPermuta(
      mensagensErro.permutaNoLocalFiscalCasas,
      mensagensErro.permutaNoLocalFiscalLotes,
      mensagensErro.permutaForaDoLocalFiscal,
      erroPermutaFinanceiraBruta,
      mensagensErro.porcentagemDescontoPermutaFinanceira,
      mensagensErro.valorEscrituradoTerreno
    )

    setMensagensErro(validador)
    validarPermutaFinanceira(validador)
  }

  const validarDescontoPermutaFinanceira = () => {
    const erroDescontoPermutaFinanceira = mensagensErro.validarInputPorcentagemUsuario(valores.porcentagemDescontoPermutaFinanceira.toString())

    const validador = new ValidacaoDadosPermuta(
      mensagensErro.permutaNoLocalFiscalCasas,
      mensagensErro.permutaNoLocalFiscalLotes,
      mensagensErro.permutaForaDoLocalFiscal,
      mensagensErro.porcetagemVgvPermutaFinanceiraBruta,
      erroDescontoPermutaFinanceira,
      mensagensErro.valorEscrituradoTerreno
    )

    setMensagensErro(validador)
    validarPermutaFinanceira(validador)
  }

  const validarValorEscrituradoTerreno = () => {
    const erroValorEscrituradoTerreno = mensagensErro.validarInputUsuario(valores.valorEscrituradoTerreno.toString())

    const validador = new ValidacaoDadosPermuta(
      mensagensErro.permutaNoLocalFiscalCasas,
      mensagensErro.permutaNoLocalFiscalLotes,
      mensagensErro.permutaForaDoLocalFiscal,
      mensagensErro.porcetagemVgvPermutaFinanceiraBruta,
      mensagensErro.porcentagemDescontoPermutaFinanceira,
      erroValorEscrituradoTerreno
    )

    setMensagensErro(validador)
    validarPermutaFinanceira(validador)
  }

  const validarPermutaFinanceira = (validador: ValidacaoDadosPermuta) => {
    const state = { ...valores } as DadosPermuta

    state.valido = validador.validarPermutaFinanceira(state)
    setValores(state)
    dadosPermutaHandler(state)
  }

  return (
    <S.Wrapper data-cy="sessaoPermuta">
      <S.NomeSecao>
        Permuta <S.SecaoOpcional>{secaoOpcional}</S.SecaoOpcional>
      </S.NomeSecao>
      <S.NomeSubSessao>FÍSICA</S.NomeSubSessao>
      <S.GridCustomizado orientacao="column" gridTemplateColumns="repeat(3,280px)" gridTemplateRow="1fr" gridGap="72px" margin="0 0 48px 0">
        <div>
          <S.Label>Valor Permutas No Local Valor Fiscal - Casas (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="permutaNoLocalFiscalCasas"
            data-cy="campoPermutaNoLocalFiscalCasas"
            value={valores.permutaNoLocalFiscalCasas}
            onChange={camposHandler}
            onBlur={validarPermutaNoLocalFiscalCasas}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.permutaNoLocalFiscalCasas != ''}
            helperText={mensagensErro.permutaNoLocalFiscalCasas}
          />
        </div>
        <div>
          <S.Label>Valor Permutas No Local Valor Fiscal - Lotes (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="permutaNoLocalFiscalLotes"
            data-cy="campoPermutaNoLocalFiscalLotes"
            value={valores.permutaNoLocalFiscalLotes}
            onChange={camposHandler}
            onBlur={validarPermutaNoLocalFiscalLotes}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.permutaNoLocalFiscalLotes != ''}
            helperText={mensagensErro.permutaNoLocalFiscalLotes}
          />
        </div>
        <div>
          <S.Label>Valor Permutas Fora do Local Valor Fiscal (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="permutaForaDoLocalFiscal"
            data-cy="campoPermutaForaDoLocalFiscal"
            value={valores.permutaForaDoLocalFiscal}
            onChange={camposHandler}
            onBlur={validarPermutaForaDoLocalFiscal}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.permutaForaDoLocalFiscal != ''}
            helperText={mensagensErro.permutaForaDoLocalFiscal}
          />
        </div>
      </S.GridCustomizado>
      <S.NomeSubSessao>FINANCEIRA</S.NomeSubSessao>
      <S.GridCustomizado orientacao="column" gridTemplateColumns="repeat(3,280px)" gridTemplateRow="1fr" gridGap="72px" margin="0 0 48px 0">
        <div>
          <S.Label>Permuta Financeira Bruta (% VGV)</S.Label>
          <TextField
            placeholder="00,00"
            type="text"
            name="porcetagemVgvPermutaFinanceiraBruta"
            data-cy="campoPorcetagemVgvPermutaFinanceiraBruta"
            value={valores.porcetagemVgvPermutaFinanceiraBruta}
            onChange={camposHandler}
            onBlur={validarPermutaFinanceiraBruta}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.porcetagemVgvPermutaFinanceiraBruta != ''}
            helperText={mensagensErro.porcetagemVgvPermutaFinanceiraBruta}
          />
        </div>
        <div>
          <S.Label>Desconto sobre Permuta Financeira (%)</S.Label>
          <TextField
            placeholder="00,00"
            type="text"
            name="porcentagemDescontoPermutaFinanceira"
            data-cy="campoPorcentagemDescontoPermutaFinanceira"
            value={valores.porcentagemDescontoPermutaFinanceira}
            onChange={camposHandler}
            onBlur={validarDescontoPermutaFinanceira}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.porcentagemDescontoPermutaFinanceira != ''}
            helperText={mensagensErro.porcentagemDescontoPermutaFinanceira}
          />
        </div>
        <div>
          <S.Label>Valor Escriturado do Terreno (R$)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="valorEscrituradoTerreno"
            data-cy="campoValorEscrituradoTerreno"
            value={valores.valorEscrituradoTerreno}
            onChange={camposHandler}
            onBlur={validarValorEscrituradoTerreno}
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.valorEscrituradoTerreno != ''}
            helperText={mensagensErro.valorEscrituradoTerreno}
          />
        </div>
      </S.GridCustomizado>
    </S.Wrapper>
  )
}

export default Permuta
